import React from 'react';
import {GroupStatusEnum} from "@/lib/helper/enumType";

function GroupStatusEnumComponent({text}) {

    if (!text || text === 'none') {
        return <span></span>
    }

    return (
        <span className={`rounded-lg px-2 py-1 text-xs ${GroupStatusEnum(text, 'color')}`}>
            {GroupStatusEnum(text)}
        </span>
    );

}

export default GroupStatusEnumComponent;